export default __webpack_public_path__ + "static/media/not-found.a9b29f2d.jpg";